<template>
  <div class="navigation-sub-item">
    <RouterLink v-slot="{ href, navigate, isActive }" :to="{ name: route }">
      <a
        class="navigation-sub-item__link"
        :class="getDynamicClasses(isActive)"
        :href="link || href"
        :target="link ? '_blank' : null"
        @click="e => link || navigate(e)"
      >
        {{ $t(title) }}

        <span class="navigation-sub-item__badges">
          <NewBadge v-if="newBadge" />
          <i
            v-if="warnBadge"
            class="el-icon-warning navigation-sub-item__warn-badge"
          />
          <span
            v-if="hasCountBadge"
            class="navigation-sub-item__count-badge"
          >
            {{ badgeCount }}
          </span>
        </span>
      </a>
    </RouterLink>
  </div>
</template>

<script>
import NewBadge from '@@/common/NewBadge';

export default {
  name: 'NavigationSubItem',
  components: { NewBadge },
  computed: {
    hasCountBadge() {
      return Number(this.badgeCount) > 0;
    },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: null,
    },
    route: {
      type: String,
      default: null,
    },
    newBadge: {
      type: Boolean,
      default: false,
    },
    warnBadge: {
      type: Boolean,
      default: false,
    },
    badgeCount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    getDynamicClasses(isActive) {
      return {
        'navigation-sub-item__link--active': !this.link && isActive,
      };
    },
  },
};
</script>

<style lang="scss">
.navigation-sub-item {
  &__link {
    position: relative;
    outline: none;
    display: flex;
    align-items: center;
    transition-property: color, border-color;
    transition-duration: 0.25s;
    margin: $lb-side-nav-secondary-margin;
    padding: $lb-side-nav-secondary-padding;
    transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
      background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    font-size: $lb-side-nav-secondary-font-size;
    color: $lb-side-nav-secondary-color;
    font-weight: $lb-side-nav-secondary-font-weight;

    &::after {
      content: '';
      position: absolute;
      right: 0;
      left: auto;
      top: 0;
      bottom: 0;
      border-right: 3px solid $lb-side-nav-secondary-active-color;
      opacity: 0;
      transform: scaleY(0.0001);
      transition: transform 0.2s cubic-bezier(0.215, 0.61, 0.355, 1),
        opacity 0.2s cubic-bezier(0.215, 0.61, 0.355, 1),
        -webkit-transform 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);

      @include rtl() {
        left: 0;
        right: auto;
      }
    }

    &:hover,
    &:focus {
      color: $lb-side-nav-secondary-active-color;
    }

    &--active {
      color: $lb-side-nav-secondary-active-color;
    }
  }

  &__badges {
    display: inline-flex;
    align-items: center;
    margin: 0 0.2rem;
  }

  &__warn-badge {
    color: $lb-color-alert;
    font-size: $lb-side-nav-font-size;
  }

  &__count-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: rem-calc(20px);
    height: rem-calc(20px);
    padding: 0 rem-calc(6px);
    border-radius: 999px;
    background-color: $lb-color-alert;
    color: $lb-white;
    font-size: rem-calc(11px);
    font-weight: 700;
    line-height: 1;
    margin-inline-start: $global-margin / 2;
  }
}
</style>
